import { createStore, get, set, del } from 'idb-keyval';
import type { QueuedMutation } from './types';

const QUEUE_KEY = 'mutation-queue';
const store = createStore('freshops-offline', 'queue-store');

export async function addToQueue(mutation: QueuedMutation): Promise<void> {
  const queue = await getQueue();
  queue.push(mutation);
  await set(QUEUE_KEY, queue, store);
}

export async function getQueue(): Promise<QueuedMutation[]> {
  const queue = await get<QueuedMutation[]>(QUEUE_KEY, store);
  return queue ?? [];
}

export async function removeFromQueue(id: string): Promise<void> {
  const queue = await getQueue();
  await set(QUEUE_KEY, queue.filter((m) => m.id !== id), store);
}

export async function updateInQueue(id: string, updates: Partial<QueuedMutation>): Promise<void> {
  const queue = await getQueue();
  const idx = queue.findIndex((m) => m.id === id);
  if (idx !== -1) {
    queue[idx] = { ...queue[idx], ...updates };
    await set(QUEUE_KEY, queue, store);
  }
}

export async function clearQueue(): Promise<void> {
  await del(QUEUE_KEY, store);
}

export async function getQueueCount(): Promise<number> {
  const queue = await getQueue();
  return queue.length;
}
